import { BAR, FUNNEL, HORIZONTAL_STACKED, LINE, PIE, RADAR } from "src/components/Charts/types";

export const graphTypes = new Map([
  ['grafico-simples', {
    type: [
      {
        value: PIE,
        label: 'Pizza',
      },
      {
        value: BAR,
        label: 'Barras',
      },
      {
        value: FUNNEL,
        label: 'Funil',
      },
    ],
    multiple: [
      {
        value: BAR,
        label: 'Barras',
      },
      {
        value: PIE,
        label: 'Pizza',
      },
      {
        value: FUNNEL,
        label: 'Funil',
      },
    ],
    colorSchemeType: [
      {
        value: 'standard',
        label: 'Padrão',
      },
      {
        value: 'neutral',
        label: 'Neutro',
      },
    ],
    chartFontsType: [
      {
        value: 18,
        label: 'Grande',
      },
      {
        value: 14,
        label: 'Normal',
      },
      {
        value: 10,
        label: 'Pequeno',
      },
    ],
    grade: [
      {
        value: HORIZONTAL_STACKED,
        label: 'Barras',
      },
      {
        value: 'verticalStacked',
        label: 'Barras Verticais',
      },
      {
        value: RADAR,
        label: 'Radar',
      },
      {
        value: 'pieGrade',
        label: 'Pizza',
      },
    ],
  }],
  ['grafico-evolutivo', {
    type: [
      {
        value: LINE,
        label: 'Linhas',
      },
      {
        value: BAR,
        label: 'Barras',
      },
    ],
    colorSchemeType: [
      {
        value: 'standard',
        label: 'Padrão',
      },
      {
        value: 'neutral',
        label: 'Neutro',
      },
    ],
    chartFontsType: [
      {
        value: 18,
        label: 'Grande',
      },
      {
        value: 14,
        label: 'Normal',
      },
      {
        value: 10,
        label: 'Pequeno',
      },
    ],
  }],
  ['grafico-evolutivo-cruzamentos', {
    type: [
      {
        value: LINE,
        label: 'Linhas',
      },
      {
        value: BAR,
        label: 'Barras',
      },
    ],
    colorSchemeType: [
      {
        value: 'standard',
        label: 'Padrão',
      },
      {
        value: 'neutral',
        label: 'Neutro',
      },
    ],
    chartFontsType: [
      {
        value: 18,
        label: 'Grande',
      },
      {
        value: 14,
        label: 'Normal',
      },
      {
        value: 10,
        label: 'Pequeno',
      },
    ],
  }],
  ['cruzamentos-multiplos', {
    type: [
      {
        value: PIE,
        label: 'Pizza',
      },
      {
        value: BAR,
        label: 'Barras',
      },
    ],
    colorSchemeType: [
      {
        value: 'standard',
        label: 'Padrão',
      },
      {
        value: 'neutral',
        label: 'Neutro',
      },
    ],
    chartFontsType: [
      {
        value: 18,
        label: 'Grande',
      },
      {
        value: 14,
        label: 'Normal',
      },
      {
        value: 10,
        label: 'Pequeno',
      },
    ],
  }],
  ['correlacao', {
    type: [
      {
        value: 'simple_bubble',
        label: 'Bolha',
      },
      {
        value: 'graph_bubble',
        label: 'Grafos',
      },
      {
        value: 'tree_map',
        label: 'Árvore',
      },
    ],
    colorSchemeType: [
      {
        value: 'standard',
        label: 'Padrão',
      },
      {
        value: 'neutral',
        label: 'Neutro',
      },
    ],
    chartFontsType: [
      {
        value: 18,
        label: 'Grande',
      },
      {
        value: 14,
        label: 'Normal',
      },
      {
        value: 10,
        label: 'Pequeno',
      },
    ],
  }],
  ['correlacaoAuto', {
    type: [
      {
        value: 'graph_bubble',
        label: 'Grafos',
      },
      {
        value: 'tree_map',
        label: 'Árvore',
      },
    ],
    colorSchemeType: [
      {
        value: 'standard',
        label: 'Padrão',
      },
      {
        value: 'neutral',
        label: 'Neutro',
      },
    ],
    chartFontsType: [
      {
        value: 18,
        label: 'Grande',
      },
      {
        value: 14,
        label: 'Normal',
      },
      {
        value: 10,
        label: 'Pequeno',
      },
    ],
  }],
  ['cruzamento-simples', {
    type: [
      {
        value: 'table',
        label: 'Tabela',
      },
      {
        value: 'bar',
        label: 'Barras',
      },
    ],
    colorSchemeType: [
      {
        value: 'standard',
        label: 'Padrão',
      },
      {
        value: 'neutral',
        label: 'Neutro',
      },
    ],
    chartFontsType: [
      {
        value: 18,
        label: 'Grande',
      },
      {
        value: 14,
        label: 'Normal',
      },
      {
        value: 10,
        label: 'Pequeno',
      },
    ],
  }],
  ['cruzamento-simples-mobile', {
    type: [
      {
        value: BAR,
        label: 'Barras',
      },
    ],
  }],
  ['simulation', {
    type: [
      {
        value: BAR,
        label: 'Barras',
      },
    ],
  }],
]);
